import PropTypes from 'prop-types'
import React from 'react'
import { Wrapper, NoteWrapper, IconWrapper } from './style'
import Info from 'Rentlio/components/Icons/info'
import { breakpoint as responsive, device } from 'Rentlio/style/responsive'

class ImportantNote extends React.PureComponent {
  mediaMatchQuery = window.matchMedia(device.tablet)

  state = {
    isMobile: window.innerWidth <= responsive.tablet
  }

  componentDidMount() {
    this.checkMediaWidth(this.mediaMatchQuery)

    // NOTE: Backward compatibility for older version of safari (13 etc. - chrome and firefox are ok here) - don't remove !
    // Please be aware that the MediaQueryList.addListener() method has been deprecated.
    // https://www.w3.org/TR/cssom-view-1/#mediaquerylist
    if (this.mediaMatchQuery?.addEventListener) {
      this.mediaMatchQuery.addEventListener('change', this.checkMediaWidth)
    } else {
      this.mediaMatchQuery.addListener(this.checkMediaWidth)
    }
  }

  componentWillUnmount() {
    if (this.mediaMatchQuery?.addEventListener) {
      this.mediaMatchQuery.removeEventListener('change', this.checkMediaWidth)
    } else {
      this.mediaMatchQuery.removeListener(this.checkMediaWidth)
    }
  }

  checkMediaWidth = (matchQuery = this.mediaMatchQuery) => {
    if (matchQuery.matches) {
      return this.setState({ isMobile: true })
    }

    this.setState({ isMobile: false })
  }

  render() {
    const { note } = this.props
    const { isMobile } = this.state
    return (
      <Wrapper>
        <IconWrapper>
          <Info width={isMobile ? 25 : 40} height={isMobile ? 25 : 40} />
        </IconWrapper>
        <NoteWrapper>{note}</NoteWrapper>
      </Wrapper>
    )
  }
}

ImportantNote.propTypes = {
  note: PropTypes.string
}
export default ImportantNote
